import { dateFnsFormat } from '@/helpers/dateFns';
import { getMonth, getYear } from 'date-fns';

/**
 * Умная сортировка массива по числовому значению, извлечённому из строки по заданному пути.
 * @param {Array} arr - Массив для сортировки.
 * @param {string} [path] - Путь к строковому параметру, например 'options.name'.
 * @returns {Array} - Отсортированный массив.
 */
export const smartNumberSort = (arr, path) => {
  // Вспомогательная функция для получения значения по пути
  const getByPath = (obj, itemPath) => {
    if (!itemPath) return obj;
    return itemPath.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
  };

  // Вспомогательная функция для извлечения первого числа из строки
  const extractFirstNumber = (str) => {
    if (typeof str !== 'string') return NaN;
    const match = str.match(/\d+/);
    return match ? Number(match[0]) : NaN;
  };

  // Копируем массив, чтобы не мутировать исходный
  return [...arr].sort((a, b) => {
    const aValue = getByPath(a, path);
    const bValue = getByPath(b, path);
    const aNum = extractFirstNumber(aValue);
    const bNum = extractFirstNumber(bValue);

    // Если оба числа валидные, сравниваем по ним
    if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
      return aNum - bNum;
    }
    // Если только одно валидное, оно идёт выше
    if (!Number.isNaN(aNum)) return -1;
    if (!Number.isNaN(bNum)) return 1;
    // Если оба невалидные, сравниваем как строки
    if (aValue === undefined && bValue !== undefined) return 1;
    if (aValue !== undefined && bValue === undefined) return -1;
    if (aValue === undefined && bValue === undefined) return 0;
    return String(aValue).localeCompare(String(bValue), 'ru');
  });
};

export const isSimmilarDates = (firstDate, secondDate, matchesNeeded = 2) => {
  if (!firstDate || !secondDate) return false;
  const { getDay } = dateFnsFormat;
  return [getDay, getMonth, getYear]
    .filter((func) => (func(new Date(firstDate)) === func(new Date(secondDate))))
    .length >= matchesNeeded;
};

export const toSnilsMask = (val) => {
  if (!val) return '';
  const num = String(val).replace(/\D/g, '').slice(0, 11);
  if (num.length < 11) return '';
  return `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6, 9)} ${num.slice(9, 11)}`;
};
